module.exports = __webpack_public_path__ + "static/media/ball_3_9.1f24f38e.mp3";